export enum ListAction {
  Sort = "sort",
  Removal = "removal",
  Toggle = "toggle",
  Custom = "custom"
}

export type SortableListItem = {
  id: string;
  label: string | React.ReactNode;
  subtitle?: string;
  toggled?: boolean;
  actionDisabled?: boolean;
  sortDisabled?: boolean;
  qaId?: string;
};
